import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';

const mutation = gql`
  mutation duplicateMenu($id: Int) {
    duplicateMenu(id: $id) {
      status
      errorMessage
      result {
        id
      }
    }
  }
`;

// The caller (MenuList) refetches its own active getAllMenu query after this
// resolves, so we don't refetch here — the component's query variables include
// searchList, which a refetchQueries entry here wouldn't match.
export default function duplicateMenu(id) {
  return async (_dispatch, _getState, { client }) => {
    try {
      const { data } = await client.mutate({
        mutation,
        variables: { id },
      });

      if (data && data.duplicateMenu && data.duplicateMenu.status === 200) {
        toastr.success('Success', 'Menu duplicated successfully.');
        return data.duplicateMenu.result && data.duplicateMenu.result.id;
      } else {
        const errorMessage = (data && data.duplicateMenu && data.duplicateMenu.errorMessage) || 'Oops! Something went wrong.';
        toastr.error('Error!', errorMessage);
        return null;
      }
    } catch (err) {
      toastr.error('Error!', err.message || err);
      return null;
    }
  };
}
